import { ConnectedPosition, Overlay, OverlayModule } from '@angular/cdk/overlay';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
  TemplateRef,
  viewChild,
  ViewContainerRef,
} from '@angular/core';

import { ButtonComponent } from '@shared/components/button/button.component';
import { ClickOutsideDirective } from '@shared/directives/click-outside.directive';
import { TooltipDirective } from '@shared/directives/tooltip.directive';
import { AuthService } from '@shared/store/auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    TooltipDirective,
    NgTemplateOutlet,
    ButtonComponent,
    ClickOutsideDirective,
    OverlayModule,
  ],
  selector: 'aux-menu',
  template: `
    @if (showMenuForExternal() || authService.isSysAdmin()) {
      <div [ngClass]="className()">
        <ng-container *ngTemplateOutlet="container"></ng-container>
      </div>
    }
    <ng-template #container>
      <aux-button
        #trigger="cdkOverlayOrigin"
        cdkOverlayOrigin
        classList="p-2"
        icon="DotsVertical"
        variant="tertiary"
        [disabled]="disabled()"
        [auxTooltip]="tooltip()"
        (click)="toggleOpen()"
      />

      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="isOpen()"
        (detach)="close()"
        [cdkConnectedOverlayPositions]="overlayPosition"
      >
        <div
          class="options mt-2 rounded-md bg-white shadow-lg"
          [class]="optionsClass()"
          (auxClickOutside)="close()"
          [skipInitial]="false"
          (click)="close()"
        >
          <ng-content></ng-content>
        </div>
      </ng-template>
    </ng-template>
  `,
})
export class MenuComponent {
  authService = inject(AuthService);
  overlay = inject(Overlay);
  viewContainerRef = inject(ViewContainerRef);

  isOpen = signal(false);

  disabled = input(false);
  disabledTooltip = input('');

  tooltip = computed(() => {
    const disabled = this.disabled();
    const disabledTooltip = this.disabledTooltip();

    return disabled ? disabledTooltip : '';
  });

  className = input('');
  optionsClass = input('');
  showMenuForExternal = input(false);

  options = viewChild.required<TemplateRef<Comment>>('options');

  overlayPosition: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
    },
  ];

  close() {
    this.isOpen.set(false);
  }

  toggleOpen() {
    this.isOpen.update((prev) => !prev);
  }
}
